module.exports = "<div class=\"repo-wrapper\">\n    <div>\n        <h3 style=\"margin-top: 0px;\">{{'REPOSITORY.POP_REPOS' | translate}}</h3>\n    </div>\n    <div>\n        <list-repository-ro [repositories]=\"topRepos\"></list-repository-ro>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/repository/top-repo/top-repo.component.html
// module id = 881
// module chunks = 0